export const loadAddresses = (addresses) => {
    try {
        const sereializedAddresses = localStorage.getItem('addresses');

        if (sereializedAddresses === null) {
            return addresses;
        }
        return JSON.parse(sereializedAddresses);
    } catch (err) {
        return addresses;
    }
}

export const saveAddresses = (addresses) => {
    try {
        const sereializedAddresses = JSON.stringify(addresses);
        localStorage.setItem('addresses', sereializedAddresses);
    } catch (err) {
        // Ignore write errors.
    }
}